import { BuyOnUniswapV2Fork } from './actions/BuyOnUniswapV2Fork';
import { MegaSwap } from './actions/MegaSwap';
import { MultiSwap } from './actions/MultiSwap';
import { SimpleBuy } from './actions/SimpleBuy';
import { SimpleSwap } from './actions/simpleSwap';
import { SwapOnUniswapV2Fork } from './actions/swapOnUniswapV2Fork';
import { SwapOnZeroXv4 } from './actions/SwapOnZeroXv4';
var actions = {
    BuyOnUniswapV2Fork: BuyOnUniswapV2Fork,
    MegaSwap: MegaSwap,
    MultiSwap: MultiSwap,
    SimpleBuy: SimpleBuy,
    SimpleSwap: SimpleSwap,
    SwapOnUniswapV2Fork: SwapOnUniswapV2Fork,
    SwapOnZeroXv4: SwapOnZeroXv4,
};
var Paraswap = {
    actions: actions,
};
export { Paraswap };
